import { Component, ComponentRef, Type, ViewContainerRef } from '@angular/core';
import { StringWhitespaceOrEmptyComponent } from '../../default/string-whitespace-or-empty/string-whitespace-or-empty.component';
import { StringOrEmptyComponent } from '../../default/string-or-empty/string-or-empty.component';
import { BooleanComponent } from '../../default/boolean/boolean.component';
import { StatusComponent } from '../../default/status/status.component';
import { DatetimeComponent } from '../../default/datetime/datetime.component';
import { MoneyComponent } from '../../default/money/money.component';
import { CurrencyComponent } from '../../default/currency/currency.component';
import { ProtectedFieldComponent } from '../../default/protected/protected.component';
import { CountryComponent } from '../../default/country/country.component';
import { CountriesComponent } from '../../default/countries/countries.component';
import { LanguageComponent } from '../../default/language/language.component';
import { LanguagesComponent } from '../../default/languages/languages.component';
import { StringWhitespaceOrEmptyWithCopyComponent } from '../../default/string-whitespace-or-empty-with-copy/string-whitespace-or-empty-with-copy.component';
import { INFO_MODAL_DATA } from '../../../../modals/info/info.modal';
import { AuthorComponent } from '../../default/author/author.component';
import { NumberStatusComponent } from '../../default/number-status/number-status.component';
import { PostbackStatusComponent } from '../../default/postback-status/postback-status.component';
import { NotificationDescriptionComponent } from '../../../notification-description/notification-description.component';
import { NumberComponent } from '../../default/number/number.component';
import { PercentComponent } from '../../default/percent/percent.component';
import { ViewModeComponent } from '../../default/view-mode/view-mode.component';
import { RbacPermissionsConstant } from '../../../../services/rbac/rbac-permissions.constant';
import { LinkComponent } from '../../default/link/link.component';
import { AffiliateLinkWithAllComponent } from '../../default/affiliate-link-with-all/affiliate-link-with-all.component';
import { ConversionTrackingTypeComponent } from '../../special/conversion-tracking-type/conversion-tracking-type.component';
import { AffiliatesTrackersTypeComponent } from '../../special/affiliates-trackers-type/affiliates-trackers-type.component';
import { GoalRevenueTypeComponent } from '../../special/goal-revenue-type/goal-revenue-type.component';
import { GoalPayoutTypeComponent } from '../../special/goal-payout-type/goal-payout-type.component';
import { AffiliatePdfComponent } from '../../special/affiliate-pdf/affiliate-pdf.component';
import { AuthAsComponent } from '../../special/auth-as/auth-as.component';
import { NotificationTypeComponent } from '../../special/notification-type/notification-type.component';
import { BaselineCumulativeComponent } from '../../special/baseline-cumulative/baseline-cumulative.component';
import { OfferUrlSourceComponent } from '../../default/offer-url-source/offer-url-source.component';
import { GoalTypesComponent } from '../../default/goal-types/goal-types.component';
import { InvoiceStatusComponent } from '../../default/invoice-status/invoice-status.component';
import { BusinessFormatComponent } from '../../default/business-format/business-format.component';
import { BusinessModelFormatComponent } from '../../default/business-model-format/business-model-format.component';
import { StringListProtectedComponent } from '../../default/string-list-protected/string-list-protected.component';
import { AffiliateAnswersComponent } from '../../special/affiliate-answers/affiliate-answers.component';
import { TreeMoneyFormatComponent } from '../../special/tree-money-format/tree-money-format.component';
import { LinksComponent } from '../../default/links/links.component';
import { EarningStatusComponent } from '../../default/earning-status/earning-status.component';
import { FinancePaymentStatusComponent } from '../../default/finance-payment-status/finance-payment-status.component';
import { FinanceInvoiceStatusComponent } from '../../default/finance-invoice-status/finance-invoice-status.component';
import { StatusHistoryComponent } from '../../default/status-history/status-history.component';
import { DateFilterComponent } from '../../default/date-filter/date-filter.component';
import { AttachmentsComponent } from '../../special/attachments/attachments.component';
import { PaymentMethodStatusComponent } from '../../default/payment-method-status/payment-method-status.component';
import { PaymentMethodTypeComponent } from '../../special/payment-method-type/payment-method-type.component';
import { RegionComponent } from '../../default/region/region.component';
import { AffiliateRequestStatusHistoryComponent } from '../../default/affiliate-request-status-history/affiliate-request-status-history.component';
import { AffiliateRequestStatusComponent } from '../../default/affiliate-request-status/affiliate-request-status.component';
import { CrmQuestionsLinkComponent } from '../../default/crm-questions-link/crm-questions-link.component';
import { ComparingAnalyticsDifferenceTypeComponent } from '../../special/comparing-analytics-difference-type/comparing-analytics-difference-type.component';
import { ComparingNumberComponent } from '../../special/comparing-number/comparing-number.component';
import { ComparingPercentageComponent } from '../../special/comparing-percentage/comparing-percentage.component';
import { ReferralPayoutsComponent } from '../../special/referral-payouts/referral-payouts.component';
import { StringComponent } from '../../default/string/string.component';
import { REFERRAL_PROGRAM_TYPE } from '../../../../services/data/data-service.interface';
import { OfferDescriptionComponent } from '../../special/offer-description/offer-description.component';
import { MoneyWithCurrencyComponent } from '../../special/money-with-currency/money-with-currency.component';
import { TokenStatusComponent } from '../../default/token-status/token-status.component';
import { TokenTypeComponent } from '../../default/token-type/token-type.component';
import { OfferVerticalComponent } from '../../default/offer-vertical/offer-vertical.component';
import { TABLE_TRANSLATIONS } from '../../../facade/table-facade/table-translation.const';

const infoModalData = INFO_MODAL_DATA;

const components: Record<string, Type<any> | IComponent> = {
  string_or_empty: StringOrEmptyComponent,
  countries: CountriesComponent,
  language: LanguageComponent,
  languages: LanguagesComponent,
  string_whitespace_or_empty_with_copy: StringWhitespaceOrEmptyWithCopyComponent,
  offer_source_string_attention_copy: {
    component: StringWhitespaceOrEmptyWithCopyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('attentionData', infoModalData.OFFER_SOURCE);
      setInputFn('isAttention', data.row.source === 'LD');
    },
  },
  employee: AuthorComponent,
  offer_status: NumberStatusComponent,
  postback_status: {
    component: PostbackStatusComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('archived', data.row.archived);
      setInputFn('status', data.row.status);
    },
  },
  notification_description: NotificationDescriptionComponent,
  question: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('jsonProp', 'question');
    },
  },
  offer_url: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data?.name);
    },
  },
  number: NumberComponent,
  percentage: PercentComponent,
  percent: PercentComponent,
  'offer-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/traffic-control/offers', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
      setInputFn('type', data.type);
    },
  },
  'goal-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/settings/crm-offer-goals', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
      setInputFn('type', data.type);
    },
  },
  'click-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/traffic-data/clicks', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_CLICK_PROFILE);
      setInputFn('type', data.type);
    },
  },
  'affiliate-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/affiliates/affiliates', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE);
      setInputFn('type', data.type);
    },
  },
  'affiliate-trackers-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/affiliates/affiliates-trackers', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_AFFILIATE_TRACKERS_PROFILE);
      setInputFn('type', data.type);
    },
  },
  'affiliate-billing-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/affiliates/affiliate-invoices', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_AFFILIATES_INVOICES);
      setInputFn('type', data.type);
    },
  },
  conversion_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/traffic-data/conversions', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_CONVERION_PROFILE);
      setInputFn('type', data.type);
    },
  },
  'advertiser-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/advertisers/advertisers', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE);
      setInputFn('type', data.type);
    },
  },
  'tracking-domains-link': {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('link', ['/app/settings/crm-tracking-domains', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_TRACKING_DOMAIN_PROFILE);
      setInputFn('type', data.type);
    },
  },
  advertiser: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/advertisers/advertisers', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
    },
  },
  offer: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/traffic-control/offers', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
    },
  },
  'goal-relation-link': {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-offer-goals', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
    },
  },
  affiliate: AffiliateLinkWithAllComponent,
  affiliate_without_all: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/affiliates/affiliates', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
    },
  },
  affiliate_goal_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-offer-goals/affiliate-goal-country', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
      setInputFn('displayData', data.data);
      if (!data) {
        setInputFn('class', 'text-color--green');
      }
    },
  },
  tracking_domain: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-tracking-domains', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_TRACKING_DOMAIN_PROFILE);
      setInputFn('displayData', data.data?.content);
    },
  },
  schema_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-affiliate-kyc-schema', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_KYC_STEPS);
      setInputFn('displayData', data.data);
    },
  },
  affiliate_group: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-affiliate-groups', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_GROUP);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
    },
  },
  conversion_tracking_type: ConversionTrackingTypeComponent,
  affiliates_trackers_type: AffiliatesTrackersTypeComponent,
  revenue_type: GoalRevenueTypeComponent,
  payout_type: GoalPayoutTypeComponent,
  'gtd-affiliate-pdf': AffiliatePdfComponent,
  'gtd-auth-affiliate': {
    component: AuthAsComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('id', data.data);
      setInputFn('crmType', 'affiliate');
    },
  },
  'gtd-auth-advertiser': {
    component: AuthAsComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('id', data.data);
      setInputFn('crmType', 'advertiser');
    },
  },
  notification_type: NotificationTypeComponent,
  cum_track: BaselineCumulativeComponent,
  offer_url_source: OfferUrlSourceComponent,
  goal_type: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data?.name);
    },
  },
  many_goal_types: GoalTypesComponent,
  goal_type_optional: {
    component: StringWhitespaceOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data?.name ? data.data?.name : 'All');
    },
  },
  string: StringWhitespaceOrEmptyComponent,
  boolean: BooleanComponent,
  user_status: StatusComponent,
  datetime: DatetimeComponent,
  date: DatetimeComponent,
  money: {
    component: MoneyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('currencyCode', data.row.currency_code);
      setInputFn('customClass', 'w100 d-flex justify-content-end');
    },
  },
  currency: CurrencyComponent,
  type_protected: ProtectedFieldComponent,
  country: {
    component: CountryComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('length', 30);
    },
  },
  counties: CountriesComponent,
  invoice_status: InvoiceStatusComponent,
  business_model: {
    component: BusinessFormatComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('customClass', 'w100 d-flex justify-content-end');
    },
  },
  business_model_format: BusinessModelFormatComponent,
  goal: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-offer-goals/', data.data?.id]);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
    },
  },
  'advertiser-id': {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/advertisers/advertisers', data.data?.id]);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE);
    },
  },
  offer_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/traffic-control/offers', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
      setInputFn('type', data.type);
    },
  },
  tree_offer_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/traffic-control/offers', data.data?.id]);
      setInputFn('dataLinkName', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
      setInputFn('type', 'offer_id');
    },
  },
  goal_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-offer-goals', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
      setInputFn('type', data.type);
    },
  },
  advertiser_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/advertisers/advertisers', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE);
      setInputFn('type', data.type);
    },
  },
  affiliate_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/affiliates/affiliates', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE);
      setInputFn('type', data.type);
    },
  },
  affiliate_tracker_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/affiliates/affiliates-trackers', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_AFFILIATE_TRACKERS_PROFILE);
      setInputFn('type', data.type);
    },
  },
  invoice_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/affiliates/affiliate-invoices', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_AFFILIATES_INVOICES);
      setInputFn('type', data.type);
    },
  },
  finance_invoice_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/finance-tools/finance-invoices', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_PROFILE_INVOICE);
      setInputFn('type', data.type);
    },
  },
  finance_payment_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/finance-tools/finance-payments', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_PROFILE_PAYMENT);
      setInputFn('type', data.type);
    },
  },
  click_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/traffic-data/clicks', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_CLICK_PROFILE);
      setInputFn('type', data.type);
    },
  },
  tracking_domain_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-tracking-domains', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_TRACKING_DOMAIN_PROFILE);
      setInputFn('type', data.type);
    },
  },
  incident_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/notifications/incident', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_NOTIFICATIONS);
      setInputFn('type', data.type);
    },
  },
  payout_model_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-payout-models', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_PAYOUT_BUSINESS_MODEL);
      setInputFn('type', data.type);
    },
  },
  revenue_model_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-revenue-models', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_REVENUE_BUSINESS_MODEL);
      setInputFn('type', data.type);
    },
  },
  payout_model: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-payout-models', data.data?.id]);
      setInputFn('dataLinkName', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_PAYOUT_BUSINESS_MODEL);
      setInputFn('type', data.type);
    },
  },
  revenue_model: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-revenue-models', data.data?.id]);
      setInputFn('dataLinkName', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_REVENUE_BUSINESS_MODEL);
      setInputFn('type', data.type);
    },
  },
  advertiser_brand_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-advertiser-brands', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_ADVERTISER_BRANDS);
      setInputFn('type', data.type);
    },
  },
  global_postback_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/affiliates/affiliates-trackers-global', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_AFFILIATE_TRACKERS_PROFILE);
      setInputFn('type', data.type);
    },
  },
  affiliate_groups: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-affiliate-groups', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('relationData', null);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_GROUP);
    },
  },
  affiliate_managers: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-affiliate-manager', data.data]);
      setInputFn('displayData', data.data);
      setInputFn('relationData', null);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_MANAGERS);
    },
  },
  advertiser_brands_link: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/crm-advertiser-brands', data.data?.id]);
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_ADVERTISER_BRANDS);
    },
  },
  string_list_protected: StringListProtectedComponent,
  many_goals: {
    component: LinksComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', '/app/settings/crm-offer-goals');
      setInputFn('data', data.data);
      setInputFn('rbac', RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
      setInputFn('title', 'All Goals');
    },
  },
  offer_request_answers: AffiliateAnswersComponent,
  affiliate_answers: AffiliateAnswersComponent,
  affiliate_group_links: {
    component: LinksComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', '/app/settings/crm-affiliate-groups');
      setInputFn('data', data.data);
      setInputFn('rbac', RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_GROUP);
      setInputFn('title', 'All Groups');
    },
  },
  many_affiliates: {
    component: LinksComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', '/app/affiliates/affiliates');
      setInputFn('data', data.data);
      setInputFn('rbac', RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_GROUP);
      setInputFn('title', 'All Groups');
    },
  },
  affiliate_manager_links: {
    component: LinksComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', '/app/settings/crm-affiliate-manager');
      setInputFn('data', data.data);
      setInputFn('rbac', RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_MANAGERS);
      setInputFn('title', 'All Managers');
    },
  },
  affiliates_links: {
    component: LinksComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', '/app/affiliates/affiliates');
      setInputFn('data', data.data ?? []);
      setInputFn('rbac', RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE);
      setInputFn('title', $localize`:@@affiliate.all:All Affiliates`);
    },
  },
  advertisers_links: {
    component: LinksComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', '/app/advertisers/advertisers');
      setInputFn('data', data.data);
      setInputFn('rbac', RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE);
      setInputFn('title', 'All Advertisers');
    },
  },
  tree_money: {
    component: TreeMoneyFormatComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('format', data.row.format);
      setInputFn('data', data.data);
    },
  },
  finance_earning_status: {
    component: EarningStatusComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('status', data.data);
    },
  },
  finance_payment_status: FinancePaymentStatusComponent,
  finance_invoice_status: FinanceInvoiceStatusComponent,
  payment_method_status: PaymentMethodStatusComponent,
  finance_earning_id: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/finance-tools/earnings/', data.data]);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_SPECIAL_EARNING);
      setInputFn('displayData', data.data);
    },
  },
  status_changed_history: {
    component: StatusHistoryComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('title', $localize`:@@common.statuses_history:Statuses History`);
    },
  },
  date_filter: DateFilterComponent,
  finance_earning: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('link', ['/app/finance-tools/earnings', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_SPECIAL_EARNING);
    },
  },
  finance_invoice: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('link', ['/app/finance-tools/finance-invoices', data.data?.id]);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_PROFILE_INVOICE);
    },
  },
  attachments: AttachmentsComponent,
  payment_method: PaymentMethodTypeComponent,
  region: {
    component: RegionComponent,
    setInputs: (data: IData, setInputFn) => {
      setInputFn('data', data);
      setInputFn('countryCode', data.row.country_code);
      setInputFn('regionCode', data.row.region_code);
    },
  },
  request_change_history: {
    component: AffiliateRequestStatusHistoryComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('title', $localize`:@@common.statuses_history:Statuses History`);
    },
  },
  offer_requests_statuses: AffiliateRequestStatusComponent,
  crm_questions_offer: {
    component: CrmQuestionsLinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('offer', data.row.offer);
      setInputFn('advertiser', data.row.advertiser);
      setInputFn('type', 'offer');
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
    },
  },
  crm_questions_advertiser: {
    component: CrmQuestionsLinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('offer', data.row.offer);
      setInputFn('advertiser', data.row.advertiser);
      setInputFn('type', 'advertiser');
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
    },
  },
  comparing_analytics_difference: ComparingAnalyticsDifferenceTypeComponent,
  comparing_number: {
    component: ComparingNumberComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('customClass', 'w100 d-flex justify-content-end');
    },
  },
  comparing_percentage: {
    component: ComparingPercentageComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('customClass', 'w100 d-flex justify-content-end');
    },
  },
  referral_payouts: {
    component: ReferralPayoutsComponent,
    setInputs: (data: IData, setInputFn) => {
      setInputFn('data', data.row.referral_payouts);
    },
  },
  referral_program_privacy: {
    component: StringComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data ? 'Private' : 'Public');
    },
  },
  referral_program_type: {
    component: StringComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', REFERRAL_PROGRAM_TYPE[data.data]);
    },
  },
  referral_payout_model: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/referral-business-models', data.data?.id]);
      setInputFn('dataLinkName', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.PAGES_TABLE_REFERRAL_PAYOUT_BUSINESS_MODEL);
      setInputFn('type', data.type);
    },
  },
  referral_payout_model_id: {
    component: ViewModeComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('link', ['/app/settings/referral-business-models', data.data]);
      setInputFn('data', data.data);
      setInputFn('rbacProperty', RbacPermissionsConstant.WIDGETS_REFERRAL_PAYOUT_BUSINESS_MODEL);
      setInputFn('type', data.type);
    },
  },
  boolean_switch: {
    component: BooleanComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
    },
  },
  marketing_information: {
    component: OfferDescriptionComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
    },
  },
  money_with_currency: {
    component: MoneyWithCurrencyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
    },
  },
  affiliate_cluster: {
    component: LinkComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('displayData', data.data?.name);
      setInputFn('relationData', data.data?.id);
      setInputFn('link', ['/app/settings/affiliate-invoice-consolidation']);
      setInputFn('rbacProperty', RbacPermissionsConstant.AFFILIATE_INVOICE_CONSOLIDATION_PAGE);
    },
  },
  token_status: TokenStatusComponent,
  token_ips: StringListProtectedComponent,
  token_type: TokenTypeComponent,
  offer_vertical: {
    component: OfferVerticalComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
    },
  },
  click_hash: {
    component: StringWhitespaceOrEmptyWithCopyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', data.data);
      setInputFn('length', 32);
      setInputFn('fullWidth', true);
      setInputFn('className', 'd-flex');
    },
  },
  translatable_string: {
    component: StringOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', TABLE_TRANSLATIONS[data.data] ?? data.data);
    },
  },
  'conversion-tracking': {
    component: StringOrEmptyComponent,
    setInputs: (data, setInputFn) => {
      setInputFn('data', TABLE_TRANSLATIONS[data.data] ?? data.data);
    },
  },
};

export class ComponentFactory {
  public static create = (container: ViewContainerRef, data: IData): void => {
    const componentData = components[data.type] || StringWhitespaceOrEmptyComponent;
    if ('component' in componentData) {
      const ref = container.createComponent(componentData.component);
      componentData.setInputs(data, ref.setInput.bind(ref));
    } else {
      const ref = container.createComponent(componentData);
      ref.setInput('data', data.data);
    }
  };
}

interface IComponent {
  component: Type<any>;
  setInputs: (data: IData, fn: ComponentRef<Component>['setInput']) => void;
}

interface IData {
  type: string;
  data: any;
  row: Record<string, any>;
  source: string;
}
